<template lang="pug">
#cost-settings.center-panel.md-scrollbar.md-theme-default
  md-content.full-height.md-elevation-1(md-theme="white")
    cost-menu
    form.md-theme-default.cost-settings-form(md-theme="white" v-if="Object.keys(properties).length")      
      .md-layout.md-gutter.main-cost-layout
        .md-layout-item.md-alignment-top-left.md-size-50
          toggle-card.cost-card(:visibility="true" heading="Цена перевозки")
            module-property(v-bind:key="properties['calculation_type_coefficient'].id" v-bind:property="properties['calculation_type_coefficient']" module="cost")
            module-property(v-bind:key="properties['default_price_by_weight'].id" v-bind:property="properties['default_price_by_weight']" module="cost")
            module-property(v-bind:key="properties['default_price_by_volume'].id" v-bind:property="properties['default_price_by_volume']" module="cost") 
            module-property(v-bind:key="properties['ttn_markup'].id" v-bind:property="properties['ttn_markup']" module="cost") 
            module-property(v-bind:key="properties['agent_markup'].id" v-bind:property="properties['agent_markup']" module="cost") 
            

        .md-layout-item.md-alignment-top-left.md-size-50
          toggle-card.cost-card(:visibility="true" heading="Хранение груза")
            module-property(v-bind:key="properties['freight_storage_type'].id" v-bind:property="properties['freight_storage_type']" module="cost")
            module-property(v-bind:key="properties['freight_storage_price'].id" v-bind:property="properties['freight_storage_price']" module="cost")
            module-property(v-bind:key="properties['freight_storage_free_period'].id" v-bind:property="properties['freight_storage_free_period']" module="cost")
            module-property(v-bind:key="properties['freight_storage_free_period_forwarding'].id" v-bind:property="properties['freight_storage_free_period_forwarding']" module="cost")

        .md-layout-item.md-alignment-top-left.md-size-50
          toggle-card.cost-card(:visibility="true" heading="Настройки веса")
            module-property(v-bind:key="properties['min_weight'].id" v-bind:property="properties['min_weight']" module="cost")
            module-property(v-bind:key="properties['min_volume'].id" v-bind:property="properties['min_volume']" module="cost") 

        //.md-layout-item.md-alignment-top-left.md-size-50
          toggle-card.cost-card(:visibility="true" heading="Экспедирование")
            module-property(v-bind:key="properties['forwarding_markup_type'].id" v-bind:property="properties['forwarding_markup_type']" module="cost")
            module-property(v-bind:key="properties['forwarding_markup'].id" v-bind:property="properties['forwarding_markup']" module="cost")

        //.md-layout-item.md-alignment-top-left.md-size-50
          toggle-card.cost-card(:visibility="true" heading="Коэфициенты расчета")
            module-property(v-bind:key="properties['doom_markup_x1'].id" v-bind:property="properties['doom_markup_x1']" module="cost")
            module-property(v-bind:key="properties['doom_markup_x2'].id" v-bind:property="properties['doom_markup_x2']" module="cost")
            module-property(v-bind:key="properties['doom_markup_x3'].id" v-bind:property="properties['doom_markup_x3']" module="cost")
            module-property(v-bind:key="properties['doom_markup_x4'].id" v-bind:property="properties['doom_markup_x4']" module="cost")
            module-property(v-bind:key="properties['doom_markup_x5'].id" v-bind:property="properties['doom_markup_x5']" module="cost")
            module-property(v-bind:key="properties['doom_markup_x6'].id" v-bind:property="properties['doom_markup_x6']" module="cost")

        .md-layout-item.md-alignment-top-left.md-size-50
          toggle-card.cost-card(:visibility="true" heading="Обрешётка")
            module-property(v-bind:key="properties['doom_markup'].id" v-bind:property="properties['doom_markup']" module="cost")
            //module-property(v-bind:key="properties['doom_markup_type'].id" v-bind:property="properties['doom_markup_type']" module="cost")
            //module-property(v-bind:key="properties['doom_coefficient'].id" v-bind:property="properties['doom_coefficient']" module="cost") 
            //module-property(v-bind:key="properties['doom_markup_price'].id" v-bind:property="properties['doom_markup_price']" module="cost") 
        
        .md-layout-item.md-alignment-top-left.md-size-50
          toggle-card.cost-card(:visibility="true" heading="Наименовая услуг")
            module-property(v-bind:key="properties['forwarding_from_label'].id" v-bind:property="properties['forwarding_from_label']" module="cost")
            module-property(v-bind:key="properties['forwarding_to_label'].id" v-bind:property="properties['forwarding_to_label']" module="cost")
            module-property(v-bind:key="properties['oversize_label'].id" v-bind:property="properties['oversize_label']" module="cost")
            module-property(v-bind:key="properties['storage_label'].id" v-bind:property="properties['storage_label']" module="cost")
            module-property(v-bind:key="properties['ttn_label'].id" v-bind:property="properties['ttn_label']" module="cost")

        //.md-layout-item.md-alignment-top-left.md-size-100(v-if="otherProps && Object.keys(otherProps).length")
          toggle-card.cost-card(:visibility="true" heading="Остальные настройки")
            .md-layout.md-gutter
              .md-layout-item.md-alignment-top-left.md-size-50(v-for="property in otherProps")
                module-property( v-bind:key="property.id" v-bind:property="property" module="cost")
</template>
<script>
  import CostMenu from './menu';
  import ModuleProperty from '@/components/ModulePtoperty';
  import ToggleCard from '@/components/ToggleCard';

  export default {
    components: {CostMenu, ModuleProperty, ToggleCard},
    metaInfo() {
      return {
        title: 'Прочие настройки'
      }
    },
    data() {
      return {
        customProp: [
          'default_price_by_weight',
          'default_price_by_volume',
          'min_weight',
          'min_volume',
          'forwarding_markup_type',
          'forwarding_markup',
          'calculation_type_coefficient',
          'doom_coefficient',
          'doom_markup_type',
          'doom_markup_price',
          'freight_storage_type',
          'freight_storage_price',
          'freight_storage_free_period',
          'freight_storage_free_period_forwarding',
          'ttn_markup',
          'agent_markup',
          'doom_markup',
          /*
          'doom_markup_x1',
          'doom_markup_x2',
          'doom_markup_x3',
          'doom_markup_x4',
          'doom_markup_x5',
          'doom_markup_x6',
          */
          'forwarding_from_label',
          'forwarding_to_label',
          'oversize_label',
          'storage_label',
          'ttn_label'
        ]
      }
    },
    computed: {
      properties() {
        return this.$store.state.module.properties;
      },
      otherProps() {
        let result = {};
        Object.keys(this.properties).map(key => {
          if (!(this.customProp.indexOf(key)+1)) result[key] = this.properties[key];
        });
        return result;
      }
    },
    created() {
      this.$store.commit('setTitle', 'Прочие параметры')
      this.$store.dispatch('module/getModuleProperties', { module: 'cost' });
    }
  }
</script>
<style lang="sass">
  #cost-settings .main-cost-layout
    margin: 0px !important
  #cost-settings .cost-settings-form
    padding: 10px
</style>


// WEBPACK FOOTER //
// OtherSettings.vue?0b79d1a8